import React, {useState} from 'react';
import {Form} from "react-bootstrap";
import CreateForm from "./CreateForm";
import {ITemplate} from "../index";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {ErrorToast, SuccessToast} from "../../../shared/toasters/toasters";
import {AdminTemplateService} from "../service";

const CreateTemplate = () => {
    const {t} = useTranslation();
    const navigate = useNavigate()
    const [state, setState] = useState<ITemplate | null>(null);
    const [image, setImage] = useState<File | null>(null);

    const submitHandler = () => {
        const formData = new FormData();
        formData.append("body", JSON.stringify(state));
        image && formData.append("image", image);
        AdminTemplateService.create(formData)
            .then(() => {
                SuccessToast(t(`template.successfully_created`));
                navigate('/admin/template');
                setState(null);
            })
            .catch((error) => ErrorToast(error));
    };
    return (
        <div className="col-12">
            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    submitHandler();
                }}
            >
                <CreateForm state={state} setState={setState} setImage={setImage}/>
            </Form>
        </div>
    );
};

export default CreateTemplate;